/**
 * 「合作夥伴專區」的分享入口：https://<後臺網域>/partner（v2.61.0）
 *
 * Brad 2026-10-15：給同事的是這條連結，不是 partner 專區的網址 —— partner 的登入頁不收後臺帳密（刻意的，
 * 見 docs/PARTNER_PORTAL.md〈後臺同事一鍵開啟〉）。
 *
 *   還沒登入後臺 → 記下「登入完要來這裡」→ 後臺登入頁 → 登入完回到這裡
 *   已經登入     → 跟右上角選單同一支 /api/partner-portal/handoff 換一張 60 秒通行證 → 同一個分頁跳過去
 *
 * 用 location.replace：上一頁不會回到這個過場頁（否則按上一頁又會再換一張通行證跳走）。
 */
import React, { useEffect, useState } from "react";
import axios from "axios";

import JWTManager from "../../constant/JWTManager";
import TinyLoading from "../../components/tiny/TinyLoading";
import { clearPostLogin, rememberPostLogin } from "../../utils/postLoginRedirect";

const PATH = "/partner";

const toLogin = () => {
  rememberPostLogin(PATH);
  window.location.replace("/login");
};

export default function PartnerPortalEntry() {
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!JWTManager.getAccessToken() || !JWTManager.getRefreshToken()) {
      toLogin();
      return undefined;
    }
    clearPostLogin();
    let cancelled = false;
    axios
      .post("/api/partner-portal/handoff")
      .then((res) => {
        if (cancelled) return;
        if (res.data?.code === 1 && res.data.url) window.location.replace(res.data.url);
        else setError(res.data?.msg || "開啟失敗，請稍後再試");
      })
      .catch((e) => {
        if (cancelled) return;
        // 401 且換不到新 token：axios 攔截器已經清掉憑證 → 重新登入，登入完再回來
        if (e.response?.status === 401 || !JWTManager.getAccessToken()) {
          JWTManager.clearToken();
          toLogin();
          return;
        }
        setError(e.response?.data?.msg || "開啟失敗，請稍後再試");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
        background: "#1e1e2f",
        color: "rgba(255, 255, 255, 0.85)",
      }}
    >
      {error ? (
        <div style={{ textAlign: "center", maxWidth: 420 }}>
          <p style={{ margin: "0 0 18px", fontSize: 15, lineHeight: 1.6 }}>{error}</p>
          <a
            href="/admin"
            style={{
              display: "inline-block",
              padding: "9px 18px",
              borderRadius: 6,
              background: "#1d8cf8",
              color: "#fff",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            回到後臺
          </a>
        </div>
      ) : (
        <TinyLoading text="正在開啟合作夥伴專區" variant="block" />
      )}
    </div>
  );
}
